const haveDocuments = (documentsField, program) =>
  documentsField.some((fieldName) => program[fieldName]?.length > 0)

export default haveDocuments
